import { useEffect, useState } from 'react'
import { hydra } from '@/lib/services/Hydra'
import useGlobalStore from '@/store/useGlobalStore'
import type { HydraShipByEstimationResponse } from '@/lib/services/Hydra/shipToOptions/hydraShipByEstimation'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { HydraLines } from '@/lib/services/Hydra/account/GET/getSubscriptions'

type Props = {
  lines?: Partial<HydraLines>
  shipToAddress?: {
    address1: string
    address2?: string
    city: string
    state: string
    zip: string
    country: Alpha2CountryCode
  }
}

export const useShipByEstimation = ({ lines, shipToAddress }: Props) => {
  const {
    user: { token },
  } = useGlobalStore()

  const [shipByEstimation, setShipByEstimation] =
    useState<HydraShipByEstimationResponse | null>()

  const [isLoadingShipByEstimation, setIsLoadingShipByEstimation] =
    useState(false)

  useEffect(() => {
    if (!token) return
    ;(async () => {
      if (!lines || !shipToAddress) {
        return
      }

      setIsLoadingShipByEstimation(true)

      const data = await hydra.shipByEstimation({
        hydraToken: token,
        lines,
        shipToAddress,
      })

      setIsLoadingShipByEstimation(false)

      if (!data) {
        setShipByEstimation(null)
        return
      }

      setShipByEstimation(data)
    })()
  }, [token, shipToAddress, lines])

  return { shipByEstimation, isLoadingShipByEstimation }
}
